import React from "react";
import Background from "./Background";

const Loading = () => {
  return (
    <div>
      <div className="w-screen h-screen relative flex z-50 items-center justify-center">
        
        <div className="animate-pulse text-slate-300 font-extrabold mt-36 newfont">
          LOADING
        </div>
      </div>
      <Background />
    </div>
  );
};

export default Loading;
